import MerkezIlanlar from './MerkezIlanlar'
import YurtIlanlar from './YurtIlanlar'

const JobList = () => {
    return (
        <div>
            <MerkezIlanlar />
            <YurtIlanlar />
        </div>
    );
};

export default JobList;